
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/locksmith",
      function () {
        return require("private-next-pages/services/locksmith/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/locksmith"])
      });
    }
  